import {Component, Input} from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-validate-errors',
  templateUrl: './validate-errors.component.html',
  styleUrls: ['./validate-errors.component.scss']
})
export class ValidateErrorsComponent {

  @Input() parentFormControl: FormControl;
  @Input() margin: number = 10;
  @Input() margin_left: number;
  @Input() margin_bottom: number = 0;
  @Input() patternMessage: string;
  // gdy true, komunikat pokazuje się już podczas pisania (bez czekania na blur)
  @Input() showOnDirty: boolean = false;

  constructor(
    public translate: TranslateService
  ) {}

  get errorMessage() {
    for (const key in this.parentFormControl.errors) {
      if (this.parentFormControl.errors.hasOwnProperty(key)) {
        return validationMessage(this.translate, key, this.parentFormControl.errors[key], this.patternMessage);
      }
    }
    return null;
  }

}

export function validationMessage(translate: TranslateService, validator: string, validatorValue?: any, patternMessage?: string): string {
  const messages = {
    'required': translate.instant('FORMS.FIELD_IS_REQUIRED_WITHOUT_NOTICE'),
    'dateInvalid': translate.instant('FORMS.DATE_IS_REQUIRED'),
    'minlength': translate.instant('FORMS.MIN_LENGTH', { value: validatorValue.requiredLength }),
    'maxlength': translate.instant('FORMS.MAX_LENGTH', { value: validatorValue.requiredLength }),
    'numberRequired': translate.instant('FORMS.NUMBER_IS_REQUIRED'),
    'upperRequired': translate.instant('FORMS.UPPER_IS_REQUIRED'),
    'lowRequired': translate.instant('FORMS.LOWER_IS_REQUIRED'),
    'emailValidation': translate.instant('FORMS.EMAIL_NOT_VALID'),
    'emailCheck': translate.instant('FORMS.CHECK_EMAIL'),
    'pattern': patternMessage || translate.instant('FORMS.NOT_VALID_FIELD'),
    'matchPassword': translate.instant('FORMS.PASSWORD_IS_NOT_THE_SAME'),
    'matchPhones': translate.instant('FORMS.PHONE_NOT_MATCH'),
    'imeiTooShort': translate.instant('FORMS.IMEI_TOO_SHORT'),
    'imeiValidation': translate.instant('FORMS.WRONG_IMEI'),
    'imeiCheck': translate.instant('FORMS.CHECK_IMEI'),
    'imeiTaken': translate.instant('FORMS.TAKEN_IMEI'),
    'IMEI_NOT_EXISTS': translate.instant('FORMS.CHECK_IMEI'),
    'IMEI_TAKEN': translate.instant('FORMS.TAKEN_IMEI'),
    'requiredTrue': translate.instant('FORMS.FIELD_IS_REQUIRED_WITHOUT_NOTICE'),
    'checkCharsInPassword': translate.instant('FORMS.LOGIN_NOT_VALID_PASSWORD'),
    'checkCharsInNewPassword': translate.instant('FORMS.LOGIN_NOT_VALID_PASSWORD'),
    'checkHoursFormat': translate.instant('FORMS.NOT_VALID_HOUR'),
    'badHoursFormat': translate.instant('FORMS.BAD_HOUR'),
    'badStartHoursFormat': translate.instant('FORMS.BAD_START_HOUR'),
    'equalStartAndEndHours': translate.instant('FORMS.EQUAL_START_AND_END_HOURS'),
    'overlappingHours': translate.instant('FORMS.OVERLAPPING_HOURS'),
    'checkLengthName': translate.instant('FORMS.SINGLE_LENGTH'),
    'checkNameChars': translate.instant('FORMS.NAME_NOT_VALID'),
    'checkAreaCode': translate.instant('FORMS.AREA_CODE'),
    'checkHoursDuplicate': translate.instant('FORMS.HOUR-DUPLICATE'),
    'FifteenMinutesFormat': translate.instant('FORMS.FIFTEEN_MINUTES'),
    'checkMaximumPulse': translate.instant('FORMS.CHECK-MAXIMUM-PULSE'),
    'checkMaxHr': translate.instant('FORMS.CHECK-MAXIMUM-PULSE'),
    'wrongPesel': translate.instant('FORMS.WRONG-PESEL'),
    'forbiddenChar': translate.instant('FORMS.FORBIDDEN-CHARS'),
    'passwordMinLength': translate.instant('FORMS.TOO-SHORT-PASSWORD'),
    'minIntValue': translate.instant('FORMS.MIN-INT-VALUE'),
    'limitZeros': translate.instant('FORMS.MAX_LENGTH', { value: validatorValue.maxZeros }),
    'minLengthV2': translate.instant('FORMS.MIN_LENGTH', { value: validatorValue.minChars }),
    'maxLengthV2': translate.instant('FORMS.MAX_LENGTHV2', { value: validatorValue.minChars }),
    'min': translate.instant('FORMS.MIN_VALUE', { value: validatorValue.min }),
    'max': translate.instant('FORMS.MAX_VALUE', { value: validatorValue.max }),
    'minValueValidator': translate.instant('FORMS.MIN_VALUE', { value: validatorValue.minValue }),
    'maxValueValidator': translate.instant('FORMS.MAX_VALUE', { value: validatorValue.maxValue }),
    'dateRangeInvalid': translate.instant('FORMS.DATE_FROM_AFTER_DATE_TO'),
    'alphanumeric': translate.instant('MEDICAL.VALIDATION_ALPHANUMERIC'),
    'ngbDate': translate.instant('FORMS.NOT_VALID_FIELD'),
    'timezoneInvalid': translate.instant('FORMS.NOT_VALID_FIELD'),
  };

  return messages[validator];
}
